export default "__VITE_ASSET__50198f40__"